import React, { useState } from 'react';


import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { SurveyCreatorComponent, SurveyCreator } from "survey-creator-react";


function SurveyCreatorWidget(props) {
  return (
    <div className="survey-creator-container-desktop ">
      <SurveyCreatorComponent creator={props.creator} />
    </div>
  )
}

export default SurveyCreatorWidget;
